import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const GutterGuardInstallationPage = lazy(() => import('../pages/services/gutter-guard-installation/page'));
const StoneCoatedGutterCapPage = lazy(() => import('../pages/services/stone-coated-gutter-cap/page'));
const PremiumGutterGuardsPage = lazy(() => import('../pages/services/premium-gutter-guards/page'));
const SeamlessGuttersPage = lazy(() => import('../pages/services/seamless-gutters/page'));
const GutterCleaningPage = lazy(() => import('../pages/services/gutter-cleaning/page'));
const FrenchDrainsPage = lazy(() => import('../pages/services/french-drains/page'));
const CostsEstimatesPage = lazy(() => import('../pages/services/costs-estimates/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/services/gutter-guard-installation',
    element: <GutterGuardInstallationPage />,
  },
  {
    path: '/services/stone-coated-gutter-cap',
    element: <StoneCoatedGutterCapPage />,
  },
  {
    path: '/services/premium-gutter-guards',
    element: <PremiumGutterGuardsPage />,
  },
  {
    path: '/services/seamless-gutters',
    element: <SeamlessGuttersPage />,
  },
  {
    path: '/services/gutter-cleaning',
    element: <GutterCleaningPage />,
  },
  {
    path: '/services/french-drains',
    element: <FrenchDrainsPage />,
  },
  {
    path: '/services/costs-estimates',
    element: <CostsEstimatesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
